import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getTransportes,
  deleteTransporte,
  getTransporteById,
} from "../helpers/rutaTransportes";
import ModalTransporte from "./ModalTransporte";
import "../css/tableclientes.css";

const TableTransportes = () => {
  const [transportes, setTransportes] = useState({
    data: {},
    loading: true,
  });

  const [transporte, setTransporte] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaTransportes();
  }, []);

  const consultaTransportes = () => {
    getTransportes().then((datos) => {
      console.log("📦 Transportes:", datos);
      setTransportes({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaTransportes();
  };

  const handleShow = () => setShow(true);

  const modificaTransporte = (id) => {
    getTransporteById(id).then((resp) => {
      if (resp.ok) {
        setTransporte(resp.transporte); // ✅ ahora sí solo el objeto transporte
        handleShow();
      } else {
        console.error("❌ Error al obtener transporte:", resp.error);
      }
    });
  };

  const eliminarTransporte = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el transporte?");
    if (confirmar) {
      deleteTransporte(id).then(() => {
        consultaTransportes();
      });
    }
  };

  return (
    <div className="table-container">
      {!transportes.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th className="acciones">Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Transportes</th>
                  <th className="dom">Domicilio</th>
                  <th className="tel">Teléfono</th>
                  <th className="cuit">CUIT</th>
                  <th className="email">Email</th>
                  <th className="loca">Localidad</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(transportes.data.transportes) &&
                  transportes.data.transportes.map((transporte) =>
                  transporte.activo ? (
                    <tr key={transporte._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaTransporte(transporte._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarTransporte(transporte._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{transporte.codtra}</td>
                      <td>{transporte.transporte}</td>
                      <td>{transporte.domicilio}</td>
                      <td>{transporte.telefono}</td>
                      <td>{transporte.cuit}</td>
                      <td>{transporte.email}</td>
                      <td>{transporte.localidad?.localidad || "-"}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalTransporte
            show={show}
            handleClose={handleClose}
            transporte={transporte}
          />
        </>
      )}
    </div>
  );
};

export default TableTransportes;
